module.exports = __webpack_public_path__ + "static/media/top_catch.243696bb.png";